/**
 * @generated SignedSource<<9f5dab0e29a5dd1d4d9cb7a317d7562a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutNavigation_buyer$data = {
  readonly hasBankAccounts: boolean | null;
  readonly hasCreditCards: boolean | null;
  readonly hasShippingAddresses: boolean | null;
  readonly " $fragmentType": "CheckoutNavigation_buyer";
};
export type CheckoutNavigation_buyer$key = {
  readonly " $data"?: CheckoutNavigation_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutNavigation_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutNavigation_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasShippingAddresses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBankAccounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCreditCards",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8965018380f9353d556920ed74f30269";

export default node;
